export default "__VITE_ASSET__9fr34FB6__"